// extracted by mini-css-extract-plugin
module.exports = {"link":"ToggleSlidingPane_link__1MMjg","container":"ToggleSlidingPane_container__PIrxL","img":"ToggleSlidingPane_img__2xhO2"};